"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JavaScriptObfuscatorCLI = void 0;
require("reflect-metadata");
const JavaScriptObfuscatorCLI_1 = require("./cli/JavaScriptObfuscatorCLI");
class JavaScriptObfuscatorCLIFacade {
    static obfuscate(argv) {
        const javaScriptObfuscatorCLI = new JavaScriptObfuscatorCLI_1.JavaScriptObfuscatorCLI(argv);
        javaScriptObfuscatorCLI.initialize();
        javaScriptObfuscatorCLI.run();
    }
}
exports.JavaScriptObfuscatorCLI = JavaScriptObfuscatorCLIFacade;
